module.exports = __webpack_public_path__ + "static/media/dash-tip-icon.6b7e92db.svg";